import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class DiagnosisCaseService extends Resource {
    async getCasesForBatchActions(laboratoryId, params, filterModel) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases`, filterModel, { params })
        return response.data
    }

    async getSamplesForBatchActions(laboratoryId, params, filterModel) {
        const response = await this.axios.put(`diagnosis/laboratories/${laboratoryId}/cases/samples`, filterModel, { params })
        return response.data
    }

    async getDiagnosisCaseByCasenumber(labId, casenumber) {
        const params = { casenumber }
        return this.axios.get(`/diagnosis/laboratories/${labId}/cases/searchByNumber`, { params }).then(response => response.data)
    }

    async getDiagnosisCaseByCaseId(labId, caseId) {
        return this.axios.get(`/diagnosis/laboratories/${labId}/cases/${caseId}`).then(response => response.data)
    }
    async updateCase(labId, caseId, data) {
        return this.axios.patch(`/diagnosis/laboratories/${labId}/cases/${caseId}`, data).then(response => response.data)
    }
    async validateCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/validate`).then(response => response.data)
    }
    async addAmendment(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/addAmendment`).then(response => response.data)
    }
    async finishAmendment(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/finishAmendment`).then(response => response.data)
    }
    async getReportHistory(labId, caseId) {
        return this.axios.get(`/diagnosis/laboratories/${labId}/cases/${caseId}/reportHistory`).then(response => response.data)
    }
    async invalidateCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/invalidate`).then(response => response.data)
    }
    async validateCaseIgnoringWarnings(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/validateIgnoringWarnings`).then(response => response.data)
    }
    async informCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/inform`).then(response => response.data)
    }
    async cancelInformCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/cancelInform`).then(response => response.data)
    }
    async transcribeCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/transcribe`).then(response => response.data)
    }
    async cancelTranscribeCase(labId, caseId) {
        return this.axios.put(`/diagnosis/laboratories/${labId}/cases/${caseId}/cancelTranscription`).then(response => response.data)
    }
    async searchCaseByLabel(casenumber) {
        const params = { casenumber }
        return this.axios.get(`/diagnosis/laboratories/cases/searchByLabel`, { params }).then(response => response.data)
    }

    async exportToMyOwnCases(laboratoryId, responsibility, caseSituation, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            caseSituation,
            exportType,
            responsibility
        }
        return this.axios.put(
            `/diagnosis/laboratories/${laboratoryId}/cases/exportMyOwnCasesGrid`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
    async exportToAllCases(laboratoryId, caseSituation, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            caseSituation,
            exportType
        }
        return this.axios.put(
            `/diagnosis/laboratories/${laboratoryId}/cases/exportAllCasesGrid`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }

    async exportToConsultationCases(laboratoryId, urlExport, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/diagnosis/laboratories/${laboratoryId}/cases/${urlExport}`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }

    async generateCaseMacrosReport(laboratoryId, caseId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/macrosReport`,
            {
                headers: {
                    type: 'application/pdf'
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getSummaryByCaseSituation(filterModel) {
        return this.axios.put(`/diagnosis/laboratories/cases/getSummaryCaseBySituations`, filterModel).then(response => response.data)
    }

    async comprehensiveDiagnosisSectionsSummary(laboratoryId, caseId) {
        return this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis/sectionsSummary`).then(response => response.data)
    }
}

export default new DiagnosisCaseService()
